import { Injectable } from "@angular/core";

@Injectable()
export class SearchFieldService {

    getValueFromFieldsValues(name: string, savedFieldsValues: any): any {
        return savedFieldsValues ? savedFieldsValues[name] : null;
    }

}